// extracted by mini-css-extract-plugin
export default {"root":"qMYFg+i5QszCH5nYlYShWg=="};